config  = require('./config')
rollbar = require('./rollbar')

reporter = {}

reporter.report = (errorReport, isWindowError, error) ->
  error._isReported = true
  rollbar.reportError(errorReport.name, errorReport.message, errorReport.stack, error)

module.exports =
  report: reporter.report


// WEBPACK FOOTER //
// ./assets/js/shared/util/error/reporter.coffee